import React, { useState, forwardRef, useImperativeHandle } from 'react';
import { XSquare } from 'react-feather';

import './Popup.css';


export const Popup = forwardRef(({ children, className, closeOnClickAway, onClose, closeButton }, ref) => {

    const [visible, setVisible] = useState(false);

    useImperativeHandle(ref, () => ({

        show() {
            //document.body.style.overflow = 'hidden';
            setVisible(true);
        },

        close() {
            //document.body.style.overflow = 'auto';
            setVisible(false);

            if (onClose) {
                setTimeout(() => {
                    onClose();
                }, 100);
            }
        }

    }));

    const closeModal = () => {
        //document.body.style.overflow = 'auto';
        setVisible(false);

        if (onClose) {
            setTimeout(() => {
                onClose();
            }, 100);
        }
    }

    return (
        <div>
            {visible &&
                <div>

                    <div className={closeOnClickAway ? 'backSplash clickable' : 'backSplash'} onClick={() => { if (closeOnClickAway === true) { closeModal() } }} />
                    <div className={className ? `${className} noscrollbar ` : 'popup noscrollbar'}>
                        {closeButton &&
                            <div className="close-icon"><XSquare className='icon btn-close' onClick={() => { closeModal() }} /></div>
                        }


                        {children}
                    </div>

                </div>
            }
        </div>
    )

});